export default "__VITE_ASSET__B3CNm$KG__"